import { TOTAL_AUCTION_TOKENS, AUCTION_DAYS } from './constants';

const BASE_AMOUNT = TOTAL_AUCTION_TOKENS / AUCTION_DAYS; // 750,000 JINU per day
const FLUCTUATION = 0.35; // 35% max fluctuation

// Seeded random function for consistent results
const seededRandom = (seed) => {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
};

// Test function to verify allocations
const verifyAllocations = (allocations) => {
    const total = allocations.reduce((sum, day) => sum + day.amount, 0);
    console.log('Daily Allocations:', allocations.map((day, index) => ({
        day: index + 1,
        amount: day.amount,
        bonus: day.bonus
    })));
    console.log('Total JINU allocated:', total);
    console.log('Expected total:', TOTAL_AUCTION_TOKENS);
    console.log('Difference:', total - TOTAL_AUCTION_TOKENS);
    return total === TOTAL_AUCTION_TOKENS;
};

export const generateDailyAllocations = () => {
    // Check if we have stored allocations
    const storedAllocations = localStorage.getItem('dailyJinuAllocations');
    if (storedAllocations) {
        return JSON.parse(storedAllocations);
    }
    
    let allocations = [];
    let totalAllocated = 0;
    
    // First pass: generate random allocations for auction days only (1-50)
    for (let i = 0; i < AUCTION_DAYS; i++) {
        // Use seeded random for consistent results
        const day = i + 1;
        const fluctuation = (seededRandom(day * 123) * 2 - 1) * FLUCTUATION;
        const allocation = Math.floor(BASE_AMOUNT * (1 + fluctuation));
        allocations.push(allocation);
        totalAllocated += allocation;
    }
    
    // Adjust to ensure total equals TOTAL_AUCTION_TOKENS
    const adjustmentFactor = TOTAL_AUCTION_TOKENS / totalAllocated;
    allocations = allocations.map(amount => Math.floor(amount * adjustmentFactor));
    
    // Final check to ensure we hit exactly TOTAL_AUCTION_TOKENS
    const finalTotal = allocations.reduce((sum, amount) => sum + amount, 0);
    if (finalTotal !== TOTAL_AUCTION_TOKENS) {
        // Add any remaining difference to the last day
        const difference = TOTAL_AUCTION_TOKENS - finalTotal;
        allocations[AUCTION_DAYS - 1] += difference;
    }
    
    // Calculate final adjustments and percentages
    const result = allocations.map((amount, index) => {
        const percentDiff = ((amount - BASE_AMOUNT) / BASE_AMOUNT) * 100;
        return {
            amount,
            bonus: percentDiff > 0 ? `+${percentDiff.toFixed(1)}%` : `${percentDiff.toFixed(1)}%`
        };
    });

    // Store the allocations in localStorage
    localStorage.setItem('dailyJinuAllocations', JSON.stringify(result));
    
    // Verify the allocations
    const isValid = verifyAllocations(result);
    if (!isValid) {
        console.error('❌ Total allocation does not match expected total!');
    } else {
        console.log('✅ Total allocation exactly matches 37.5M JINU');
    }

    return result;
};

// Cache the allocations
let cachedAllocations = null;

export const getDailyAllocation = (day) => {
    if (!cachedAllocations) {
        cachedAllocations = generateDailyAllocations();
    }
    
    if (day < 1 || day > AUCTION_DAYS) {
        return null;
    }
    
    return cachedAllocations[day - 1];
};

// Initial verification on module load
generateDailyAllocations();
